import React from 'react';
import { useLocale, useTranslations } from 'next-intl';
import { LanguageCodeEnum } from '@/shared/config/common/constants/lang';
import { classNames } from '@/shared/lib/classnames/classnames';
import { getFormattedDate } from '@/shared/lib/date/getFormattedDate';
import type { ISchedule } from '@/entities/booking/model/types';
import type { DayItemProps } from '../../model/types';
export const DayItem: React.FC<DayItemProps> = ({
  day,
  isSelected,
  onClick
}) => {
  const currentLocale = useLocale();
  const t = useTranslations('doctor.schedule');
  const isCurrentDay = () => {
    const date = getFormattedDate(new Date().toString(), {
      locale: LanguageCodeEnum.RU,
      format: 'YYYY-MM-DD'
    });
    return date === day.date;
  };
  const getDayName = () => {
    const date = new Date(day.date);
    return getFormattedDate(date.toString(), {
      locale: currentLocale as LanguageCodeEnum,
      format: 'dd'
    });
  };
  const dayClick = () => {
    if (!day.isWork || !day.timeslots || day.timeslots.length === 0) return;
    onClick(day);
  };
  const getFormattedPeriod = (day: ISchedule) => {
    if (day.is24HoursWork) return t('aroundTheClock');
    if (day.timeslots!.length === 1) return `${day.timeslots![0]}`;
    return t('period', {
      start: day.timeslots![0],
      end: day.timeslots![day.timeslots!.length - 1]
    });
  };
  return <button className={classNames(`flex w-27 flex-none select-none flex-col rounded-2lg border border-solid px-3 py-2`, {
    'border-primary': isSelected,
    'border-borderSecondary': !isSelected,
    'cursor-not-allowed opacity-50': !day.isWork || !day.timeslots || day.timeslots.length === 0
  })} data-testgroup="days-booking" onClick={dayClick} data-sentry-component="DayItem" data-sentry-source-file="DayItem.tsx">
      <p className="text-sm">
        {getFormattedDate(day.date, {
        locale: currentLocale as LanguageCodeEnum,
        format: 'DD MMM'
      })}
      </p>

      <p className="mb-2 text-xs text-textSecondary">{isCurrentDay() ? t('today') : getDayName()}</p>

      {!day.isWork && <p className="text-xs text-textSecondary">{t('weekend')}</p>}
      {day.isWork && day.timeslots && day.timeslots.length > 0 && <p className="text-xs text-textSecondary">{getFormattedPeriod(day)}</p>}
      {day.isWork && (!day.timeslots || day.timeslots.length === 0) && <p className="text-xs text-textSecondary">{t('busy')}</p>}
    </button>;
};